import React from "react";
import { AppContext } from "../context";
import { useI18n } from "../i18n";

const NavLinks = () => {
  // function from context
  const { smoothScroll } = React.useContext(AppContext);
  const { t } = useI18n();

  const links = [
    { id: 1, url: "#home", text: t.nav.home },
    { id: 2, url: "#about", text: t.nav.about },
    { id: 3, url: "#projects", text: t.nav.projects },
    { id: 4, url: "#contact", text: t.nav.contact },
  ];

  // jsx
  return (
    <>
      {links.map(({ id, url, text }) => {
        return (
          <li key={id}>
            <a href={url} className="link" onClick={(e) => smoothScroll(e)}>
              {text}
            </a>
          </li>
        );
      })}
    </>
  );
};

export default NavLinks;
